module.exports = __webpack_public_path__ + "img/Picture15.f0e7805a.png";